// extracted by mini-css-extract-plugin
export var attachment = "PartnerSupportCasePage-module__attachment___L3rEw";
export var attachmentName = "PartnerSupportCasePage-module__attachmentName___54rf7";
export var attachments = "PartnerSupportCasePage-module__attachments___vkv8V";
export var avatar = "PartnerSupportCasePage-module__avatar___Wzm2L";
export var bubble = "PartnerSupportCasePage-module__bubble___GJl0m";
export var caseHeader = "PartnerSupportCasePage-module__caseHeader___T75TH";
export var closed = "PartnerSupportCasePage-module__closed___EAAP5";
export var closedNotice = "PartnerSupportCasePage-module__closedNotice___TAwXf";
export var columns = "PartnerSupportCasePage-module__columns___8ClZG";
export var composer = "PartnerSupportCasePage-module__composer___Fo0lO";
export var composerRow = "PartnerSupportCasePage-module__composerRow___g5DU5";
export var confirmActions = "PartnerSupportCasePage-module__confirmActions___EUNO+";
export var confirmDialog = "PartnerSupportCasePage-module__confirmDialog___wLiLP";
export var confirmHeader = "PartnerSupportCasePage-module__confirmHeader___79JjU";
export var detailGroup = "PartnerSupportCasePage-module__detailGroup___6TeJ+";
export var details = "PartnerSupportCasePage-module__details___wlVva";
export var game = "PartnerSupportCasePage-module__game___Mdx+R";
export var gameIcon = "PartnerSupportCasePage-module__gameIcon___vHaN+";
export var gameName = "PartnerSupportCasePage-module__gameName___9SXrn";
export var high = "PartnerSupportCasePage-module__high___e2lI+";
export var iconButton = "PartnerSupportCasePage-module__iconButton___ppxTi";
export var loadEarlier = "PartnerSupportCasePage-module__loadEarlier___ml51D";
export var low = "PartnerSupportCasePage-module__low___PqD2V";
export var main = "PartnerSupportCasePage-module__main___Y8zdA";
export var medium = "PartnerSupportCasePage-module__medium___apKZ-";
export var menu = "PartnerSupportCasePage-module__menu___Td2t5";
export var menuButton = "PartnerSupportCasePage-module__menuButton___NMGmO";
export var menuItem = "PartnerSupportCasePage-module__menuItem___fTVj6";
export var message = "PartnerSupportCasePage-module__message___c252B";
export var messageMeta = "PartnerSupportCasePage-module__messageMeta___nvc48";
export var messages = "PartnerSupportCasePage-module__messages___R3MhN";
export var muted = "PartnerSupportCasePage-module__muted___4+KpN";
export var notice = "PartnerSupportCasePage-module__notice___XWzZS";
export var pageMessage = "PartnerSupportCasePage-module__pageMessage___7xvtm";
export var partner = "PartnerSupportCasePage-module__partner___KNj8A";
export var previewAction = "PartnerSupportCasePage-module__previewAction___HCrtn";
export var previewDialog = "PartnerSupportCasePage-module__previewDialog___hOosp";
export var previewHeader = "PartnerSupportCasePage-module__previewHeader___W0iw5";
export var sendButton = "PartnerSupportCasePage-module__sendButton___xYYdB";
export var status = "PartnerSupportCasePage-module__status___x3ZWB";
export var support = "PartnerSupportCasePage-module__support___1CARV";
export var tag = "PartnerSupportCasePage-module__tag___gofzo";
export var tags = "PartnerSupportCasePage-module__tags___kewPL";
export var thread = "PartnerSupportCasePage-module__thread___+lKqW";
export var thumbnail = "PartnerSupportCasePage-module__thumbnail___OYm-x";